<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
</script>

<div class="box">
	<div class="header">
		<div class="dragHandle" contenteditable="false" data-drag-handle />
		<slot name="header" />

		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div class="delete" on:keydown={null} on:click={() => dispatch('delete')}>
			<Icon icon="delete" />
		</div>
	</div>

	<slot />
</div>

<style>
	.header {
		display: flex;
		justify-content: space-between;
	}

	.box {
		margin-block-end: 20px;
		margin-inline: 5px;
		padding-inline: 1.2rem;
		clear: both;
		background-color: white;
		box-shadow: 0 20px 25px -5px rgb(0 0 0 / 10%), 0 8px 10px -6px rgb(0 0 0 / 10%);
	}

	.dragHandle {
		position: relative;
		flex: 0 0 auto;
		block-size: 1rem;
		inline-size: 1rem;
		margin-block-end: 1rem;
		margin-inline-end: 0.5rem;
		background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16"><path fill-opacity="0.2" d="M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" /></svg>');
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
		cursor: grab;
		inset-block-start: 0.3rem;
	}

	.delete {
		margin-block-end: 0.3rem;
	}

	.delete :global(span::before) {
		transition-property: opacity;
		transition-duration: 300ms;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		opacity: 0.2;
		cursor: pointer;
	}

	.delete:hover :global(span::before) {
		opacity: 1;
	}
</style>
